export const selectTypeChart = {
  display: 'flex',
  alignItems: 'center'
};
